import React, { useMemo } from 'react';
import { Rate } from 'tea-component';
import './index.scss';
const Score = ({ data }: any) => {
  const score = useMemo(() => {
    return Number(data?.comment_score || 0);
  }, [data]);

  return (
    <div className="dbo-score-text">
      <Rate theme="primary" readonly defaultValue={score} />
      <span className="dbo-score-text-style">{score?.toFixed(1)}</span>
    </div>
  );
};

export default Score;
